module.exports = __webpack_public_path__ + "img/img_new.f02287c2.svg";